export const BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

